var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('div',{staticClass:"head fixed-top d-flex align-items-center",class:{ 'justify-content-center': _vm.isIPhone() },on:{"click":_vm.clickByPanelHeader}},[_c('div',{staticClass:"arrow"},[_vm._t("arrow")],2),_c('div',{class:{ 'margin-title ': ! _vm.isIPhone() && _vm.hasArrowSlot() }},[_vm._t("text")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }